/**
 * @generated SignedSource<<4d6fb76146bcf3b30c073fc3ed8afe6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromptDropdown_viewer$data = {
  readonly savedPrompts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly promptText: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"PromptRow_savedPrompt">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PromptDropdown_viewer";
};
export type PromptDropdown_viewer$key = {
  readonly " $data"?: PromptDropdown_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromptDropdown_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "savedPrompts"
        ]
      }
    ]
  },
  "name": "PromptDropdown_viewer",
  "selections": [
    {
      "alias": "savedPrompts",
      "args": null,
      "concreteType": "SavedPromptTypeConnection",
      "kind": "LinkedField",
      "name": "__PromptDropdown_savedPrompts_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SavedPromptTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SavedPrompt",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "promptText",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PromptRow_savedPrompt"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "79af9d446e7d9172b74e4c296d63c2ce";

export default node;
